// extracted by mini-css-extract-plugin
export var content = "_e3-3";
export var list = "_e3-4";
export var settingsContent = "_e3-7";
export var settingsPanel = "_e3-8";
export var state = "_e3-6";
export var triggerBadge = "_e3-2";
export var triggerButton = "_e3-1";
export var triggerShell = "_e3-0";
export var unreadDot = "_e3-5";